<template>
  <div class="staff-achieve-page">
    <div>
      <!--客户数据-->
      <div class="group">
        <div class="tip">客户数据</div>
        <div class="group-item small">
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.preview.all':'kpi.achieve.preview', query: { type: 'view',  title: '客户浏览记录',act_id: activity_id }}"
          >
            <i class="icon-view"></i>
            <div>浏览客户</div>
            <div class="num">{{achievement.viewCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'fission', title: '客户裂变记录',act_id: activity_id }}"
          >
            <i class="icon-share"></i>
            <div>裂变客户</div>
            <div class="num">{{achievement.fissionCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'enrollment', title: '客户报名记录',act_id: activity_id }}"
          >
            <i class="icon-enrrol"></i>
            <div>报名客户</div>
            <div class="num">{{achievement.enrollmentCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'card', title: '客户售卡记录',act_id: activity_id }}"
          >
            <i class="icon-sale"></i>
            <div>售卡客户</div>
            <div class="num">{{achievement.cardCount||0}}</div>
          </router-link>
        </div>
        <div class="group-item small">
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.market.all':'kpi.achieve.market', query: { type: 'seckill_user', title: '秒杀客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>秒杀客户</div>
            <div class="num">{{achievement.seckillUserCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.market.all':'kpi.achieve.market', query: { type: 'go_shop', title: '逛店客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>逛店客户</div>
            <div class="num">{{achievement.goShopCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.market.all':'kpi.achieve.market', query: { type: 'thumb', title: '集赞客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>集赞客户</div>
            <div class="num">{{achievement.thumbCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'process_self_order', title: '过程转单客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>过程转单客户</div>
            <div class="num">{{achievement.processSelfOrderCount||0}}</div>
          </router-link>
        </div>
        <div class="group-item small">
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'live_view', title: '进直播间客户记录',act_id: activity_id }}"
          >
            <i class="icon_live_appointment_people"></i>
            <div>进直播间客户</div>
            <div class="num">{{achievement.liveViewCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'live_order_cus', title: '直播下订客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>直播下订客户</div>
            <div class="num">{{achievement.liveOrderCusCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'act_sign', title: '客户签到记录',act_id: activity_id }}"
          >
            <i class="icon-order"></i>
            <div>签到客户</div>
            <div class="num">{{achievement.actSignCount||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'live_self_order_change', title: '直播转单客户',act_id: activity_id }}"
          >
            <i class="icon-live-order"></i>
            <div>直播转单客户</div>
            <div class="num">{{achievement.liveSelfOrderChangeCount||0}}</div>
          </router-link>
        </div>
        <div class="group-item small">
          <router-link
              :to="{ name: userType&&userType!='staff'?'kpi.achieve.detail.all':'kpi.achieve.detail', query: { type: 'appointment', title: '直播预约客户',act_id: activity_id }}"
          >
            <i class="icon_live_appointment_people"></i>
            <div>直播预约客户</div>
            <div class="num">{{achievement.appointmentCount||0}}</div>
          </router-link>
        </div>
      </div>

      <!--业绩数据-->
      <div class="group">
        <div class="tip">业绩</div>
        <div class="group-item small">
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: {  type: 'live_self_order', title: '直播自签订单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>直播自签订单</div>
            <div class="num">{{achievement.liveSelfOrderCountOrder||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'live_other_order', title: '直播贡献订单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>直播贡献订单</div>
            <div class="num">{{achievement.liveOtherOrderCountOrder||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'live_self_order_change', title: '直播自签转单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>直播自签转单</div>
            <div class="num">{{achievement.liveSelfOrderChangeCountOrder||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'live_other_order_change', title: '直播贡献转单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>直播贡献转单</div>
            <div class="num">{{achievement.liveOtherOrderChangeCountOrder||0}}</div>
          </router-link>
        </div>
        <div class="group-item small">
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'seckill_user',title: '秒杀品订单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>秒杀订单</div>
            <div class="num">{{achievement.seckillUserCountOrder||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'process_self_order', title: '过程自签订单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>过程自签订单</div>
            <div class="num">{{achievement.processSelfOrderCountOrder||0}}</div>
          </router-link>
          <router-link
            :to="{ name: userType&&userType!='staff'?'kpi.achieve.order.all':'kpi.achieve.order', query: { type: 'process_devote_order', title: '过程贡献订单明细',act_id: activity_id }}"
          >
            <i class="icon-devote-order"></i>
            <div>过程贡献订单</div>
            <div class="num">{{achievement.processDevoteOrderCountOrder||0}}</div>
          </router-link>
        </div>
      </div>
    </div>

    <back-home
      :activity_id="activity_id"
      :user_id="user_id"
      :kpi_uid="kpi_userid"
      :share_uid="share_userid"
    ></back-home>

    <app-footer></app-footer>
  </div>
</template>

<script>
import backHome from "../../components/back-home.vue";
import appFooter from "../../components/app-footer";

export default {
  components: {
    backHome,
    appFooter,
  },
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      share_userid: localStorage.getItem("share_user_id") || null,
      userType: localStorage.getItem("userType") || "",
      achievement: {},
    };
  },
  created() {
    this.activity_id =
      this.$route.query.act_id || localStorage.getItem("act_id");
    this.getAchievement();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取业绩信息
    getAchievement() {
      this.$store.commit("setLoading", true);
      this.$kpi.achieve.getAchievementMenu().then((res) => {
        this.$store.commit("setLoading", false);
        console.log(res);
        if (res.code == 0 || res.code == 10200) {
          this.achievement = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.staff-achieve-page {
  padding: 10px 15px 50px;
  .group {
    padding: 15px 5px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    .tip {
      font-weight: bold;
      padding-left: 5px;
    }
    .group-item {
      display: flex;
      flex: 1;
      text-align: center;
      a {
        margin-top: 15px;
        width: 25%;
        line-height: 19px;
      }
      img {
        width: 22px;
        height: 22px;
      }
      .num {
        color: #999999;
      }
    }
    .small {
      font-size: 12px;
    }
  }
  .group-item {
    i {
      display: block;
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 auto 5px;
    }
    .icon-view {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -14px -9px;
      background-size: 400px 43px;
    }
    .icon-collect {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -61px -10px;
      background-size: 420px 44px;
    }
    .icon-enrrol {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -101px -8px;
      background-size: 407px 41px;
    }
    .icon-sale {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -136px -7px;
      background-size: 380px 40px;
    }
    .icon-order {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -182px -6px;
      background-size: 395px 36px;
    }
    .icon-live-order {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -201px -7px;
      background-size: 350px 40px;
    }
    .icon-share {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -253px -8px;
      background-size: 363px 41px;
    }
    .icon-devote-order {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -315px -9px;
      background-size: 390px 42px;
    }
    .icon_live_appointment {
      background: url(https://j.weizan.cn/youxiang/images/kpi-achieve-img.png)
        no-repeat -346px -9px;
      background-size: 380px 43px;
    }
    .icon_live_appointment_people {
      background: url(https://j.weizan.cn/youxiang/images/icon_live_appointment_people.png)
        no-repeat 0 1px;
      background-size: 22px 21px;
    }
  }
}
</style>
